module.exports = __webpack_public_path__ + "media/images/icons/icon_trash-d8640c8456504e5e3232b78bd8e09e8b.svg";